import { render } from "./notificationTemplates.vue?vue&type=template&id=2cd615a6"
import script from "./notificationTemplates.vue?vue&type=script&lang=js"
export * from "./notificationTemplates.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__